import React from 'react'
import { Text, TouchableOpacity } from 'react-native'
import type { VacationResponse } from '@warcarp/api-types'
import { useNow } from '../../hooks/useNow'
import { isVacationActive, vacationRemainingLabel } from '../../lib/vacation'
import { VacationDetailsModal } from './VacationDetailsModal'

export function PlayerVacationIndicator({ name, vacation, showRemaining = false, icon = false }: {
  name: string; vacation?: VacationResponse | null; showRemaining?: boolean; icon?: boolean
}) {
  const now = useNow(vacation ? 60_000 : null)
  const [open, setOpen] = React.useState(false)
  if (!isVacationActive(vacation, now)) return null
  return <>
    <TouchableOpacity accessibilityRole="button" accessibilityLabel={`${name} is on vacation`}
      onPress={event => { event.stopPropagation(); setOpen(true) }}
      className={icon ? 'bg-paper border border-olive rounded-full items-center justify-center' : 'flex-row items-center gap-1'}
      style={icon ? { width: 40, height: 40 } : { minHeight: 28, flexShrink: 0 }}>
      <Text style={{ fontSize: icon ? 26 : 18 }}>🌴</Text>
      {showRemaining && <Text className="text-ink font-typed text-xs">{vacationRemainingLabel(vacation!.endsAt, now)}</Text>}
    </TouchableOpacity>
    <VacationDetailsModal vacation={open ? { name, endsAt: vacation!.endsAt, message: vacation!.message } : null} onClose={() => setOpen(false)} />
  </>
}
